module.exports = __webpack_public_path__ + "img/mine_rz1.29b9dcdd.png";